import React from 'react';
import { motion } from 'framer-motion';
import { FileText, MonitorSmartphone, Zap, LayoutTemplate } from 'lucide-react';
const formats = [{
  text: '1 guía digital en PDF',
  icon: FileText
}, {
  text: 'diseño claro y elegante',
  icon: LayoutTemplate
}, {
  text: 'acceso inmediato después de comprar',
  icon: Zap
}, {
  text: 'lectura desde celular, tablet o computadora',
  icon: MonitorSmartphone
}];
export function ProductFormat() {
  return <section className="py-20 bg-cream" data-id="element-223">
      <div className="max-w-4xl mx-auto px-6" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 border border-bronze/20 shadow-xl shadow-bronze/5 relative overflow-hidden" data-id="element-225">
          {/* Decorative corner accent */}
          <div className="absolute top-0 right-0 w-24 h-24 bg-bronze/5 rounded-bl-full" data-id="element-226" />

          <h2 className="text-3xl font-serif mb-10 text-center" data-id="element-227">
            Tu compra incluye:
          </h2>

          <div className="space-y-6 mb-12" data-id="element-228">
            {formats.map((format, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-center gap-4 text-lg text-charcoal-light" data-id="element-229">
                <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center shrink-0" data-id="element-230">
                  <format.icon className="w-5 h-5 text-bronze" data-id="element-231" />
                </div>
                <span data-id="element-232">{format.text}</span>
              </motion.div>)}
          </div>

          <div className="bg-cream-dark/50 p-4 text-center border border-bronze/10" data-id="element-233">
            <p className="text-sm font-medium text-charcoal-light" data-id="element-234">
              Producto 100% digital. No se envía nada físico.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}